import { getPerfomanceNowTimeSec } from '../../../common/utils';

import { IMicrofrontendState } from '../../types/reducers/microfrontend';

export const defaultState: IMicrofrontendState = {
  initLoadTime: getPerfomanceNowTimeSec(),
  hostName: null,
};
